import React, { Component } from 'react';

class IconUrlLink extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="18.975" height="9.716" viewBox="0 0 18.975 9.716" fill="none" stroke="#164b90" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2px"><g transform="translate(1 1)"><path className="a" d="M12.3,10.5h2.315a3.858,3.858,0,1,1,0,7.716H12.3m-4.629,0H5.358a3.858,3.858,0,1,1,0-7.716H7.673" transform="translate(-1.5 -10.5)" /><path className="a" d="M12,18h6.173" transform="translate(-6.599 -14.142)" /></g></svg>
        );
    }
}

export default IconUrlLink;